import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { Segment } from 'src/app/models/Segment';
@Injectable({
    providedIn: 'root'
})
export class SegmentApi extends Api<Segment> {
}
